import { render } from "./ContentSubheaderPage.vue?vue&type=template&id=e8ede918"
import script from "./ContentSubheaderPage.vue?vue&type=script&lang=js"
export * from "./ContentSubheaderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__